export function get(path){
    const headers = new Headers()
    const tenant = !localStorage.getItem("liguerivesud.tenant") ? "m":localStorage.getItem("liguerivesud.tenant");
    headers.append("X-Tenant",tenant)
    return fetch(process.env.REACT_APP_DOMAIN+path,{headers:headers});
}